module.exports = __webpack_public_path__ + "img/1317706302.9a0cc0e9.jpg";